import { ILogMechanism } from '../../../Logging/ILogMechanism';
import { NamedEventCode } from '@reachmedianetwork/signage-abstractions/src/namedEventCode';
import { LogLevel } from '../../../Logging/LogLevel';
import { Nullish } from '../../../Utility/Nullish';

export class LogConsole implements ILogMechanism {
    NamedEvent(code: NamedEventCode, message: string, source: string, data: unknown): void {
        this.LogMessage(LogLevel.INFO, message, code, source, data);
    }

    LogMessage(
        level: LogLevel,
        message: string,
        code: string | Nullish,
        source: string,
        data: unknown
    ): void {
        const levelMethod = LogConsole.translateLevelCode(level);
        const showInformation = Boolean(
            level === LogLevel.DEBUG ||
                level === LogLevel.ERROR ||
                level === LogLevel.WARNING ||
                level === LogLevel.CRITICAL
        );
        const hasInformation = Boolean(code || source || data);

        if (source) {
            message = `${message} <${source}>`;
        }

        if (hasInformation && showInformation) {
            // display extra information
            const information = {
                errorCode: code,
                source: source,
                data: data,
            };
            levelMethod(level.toUpperCase() + ': ' + message, information);
        } else {
            levelMethod(level.toUpperCase() + ': ' + message);
        }
    }

    static translateLevelCode(level: LogLevel): (...data: unknown[]) => void {
        switch (level.toLowerCase()) {
            case LogLevel.DEBUG:
                return console.debug.bind(console);
            case LogLevel.INFO:
                return console.info.bind(console);
            case LogLevel.WARNING:
                return console.warn.bind(console);
            case LogLevel.ERROR:
            case LogLevel.CRITICAL:
                return console.error.bind(console);
            default:
                return console.log.bind(console);
        }
    }
}
